<template>
  <DBox
    :id="'cmp-catalog-releases-sidewindow-licences'"
    :addButton="false"
    :addLink="false"
    :addLinkLabel="`${$t('add_new')} ${$t('related_product')}`"
    :rightMenu="rightMenu"
    @menuClick="onRightMenuClick"
    :topRightMenu="[
      {
        text:
          'This Section displays licence revenue that was not yet invoiced. You can include all revenues in this section in a bulk invoice by clicking the CREATE INVOICE button.',
        icon: 'question-black.svg',
        value: 'question'
      }
    ]"
    :noSeparator="true"
  >
    <NTable
      class="dbox1"
      id="catalog-releases-sidewindow-licences"
      :config="tableConfig"
      :headers="Headers"
      :items="list"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td @click="onProductClick(item)" v-bind="tdcon('date')">
            <span>{{ item["date"] }}</span>
          </td>
          <td v-bind="tdcon('licence_name')">
            <span>{{ item["licence_name"] }}</span>
          </td>
          <td v-bind="tdcon('asset')">
            <span>{{ item["title"] }}</span>
          </td>
          <td v-bind="tdcon('period')">
            <span>{{ item["period"] }}</span>
            
          </td>
          <td v-bind="tdcon('invoice')">
            <span>{{ item["invoice"] }}</span>
            
          </td>
          <td v-bind="tdcon('currency')">
            <span>{{ item["currency"] }}</span>
            
          </td>
          <td v-bind="tdcon('options')">
           
            <div class="ut-rowcen">
              <div class="dt-checkbox v2 s1 ">
                <input
                  class="disabled"
                  type="checkbox"
                  :checked="isChecked(item)"
                  :name="'paid_flag'"
                  :id="'paid_flag'"
                  @click="e => onCheckBoxChange(e, item)"
                />
                <div class="checkmark"></div>
              </div>
            </div>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";
import { productsListLDTRoutes } from "../../router/routes";
import { addRemoveSet } from "../../../../utility";
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";
import { ConfirmationService,createConfirmResult } from '../../../../dt-plugins/confirmation/confirmation.service';

export default {
  props: {
    selectedLicenceAccountDetails: {
      type: Object
    }
  },
  components: {
    NTable,
    DBox
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },

      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      }),

      selectedLicenceLines: new Set()
    };
  },
  computed: {
    Headers: function() {
      return [
        createTableHeader("date", { text: this.firstHeaderText, f: 1.5 }),
        createTableHeader("licence_name", { f: 1.2 }),
        createTableHeader("asset", { f: 2 }),
        createTableHeader("period", { ta: "right", f: 0.5 }),
        createTableHeader("invoice", { f: 0.5 ,ta:"right" }),
        createTableHeader("currency", { f: 0.5 }),
        createTableHeader("options", { text: false, mw: 30 })
      ];
    },

    list: function() {
      return this.selectedLicenceAccountDetails.licence_lines || [];
    },
    firstHeaderText: function() {
      return this.list.length > 0 ? this.$t("not_yet_invoiced") : "licences";
    },



    rightMenu: function() {
      if (this.list.length > 0) {
        return [
          {
            text: this.$t("Create Invoice"),
            value: "create_invoice"
          }
        ];
      } else {
        return [];
      }
    }
  },

  methods: {
    isChecked:function(item){
      return this.selectedLicenceLines.has(item)?true:false
    },
    uniqueCurrencyCheck:function(){
      console.log("PPPPPPPPP",this.selectedLicenceLines)
      const arr =[...this.selectedLicenceLines].map(x=>{
        return x.currency
      })
      const uniqueCount = new Set(arr).size;

      return uniqueCount>1?true:false;
    },
    onRightMenuClick: function(menu) {
      console.log(
        this.selectedLicenceLines,
        [...this.selectedLicenceLines].length
      );
      if ([...this.selectedLicenceLines].length > 0) {

        if(this.uniqueCurrencyCheck()){
            NotificationService.showNotification({
            text: this.$t('attention_on_create_licence_invoice'),
            timeout: 5000,
            type: "error"
          });
        }else{
          this.$router.push({
            ...this.$route,
            query: {
              modal: "create_invoice_projects",
              external_id: this.selectedLicenceAccountDetails.licence_account
                .licence_account_id,
              licence_line_ids: [...this.selectedLicenceLines].map(e=>{return e.licence_line_id;})
            }
          });
        }
        
      } else {
        NotificationService.showNotification({
          text: "Must Select a Licence Line to Create Invoice",
          timeout: 5000,
          type: "error"
        });
      }
    },
    onCheckBoxChange: function(e, item) {
     
      if(this.selectedLicenceLines.size>0){
        
        let iterator = this.selectedLicenceLines.values();
        let firstItem = iterator.next();
        var firstItemValue = firstItem.value;
        console.log("::::::::::::::",firstItemValue,"::::::::::::",item);
        if(firstItemValue.currency_iso==item.currency_iso){
          this.selectedLicenceLines = addRemoveSet(
            e.target.checked,
            this.selectedLicenceLines,
            item
          );  
        }else{
          e.preventDefault()
          ConfirmationService.createP({
          body: this.$t("attention_on_create_licence_invoice"),
          results: [
            createConfirmResult({
              value: "ok",
              text: "OK",
              classes: ["v1 s7"],
            }),
          ],
        })
        }
      }else{
        this.selectedLicenceLines = addRemoveSet(
          e.target.checked,
          this.selectedLicenceLines,
          item
        );
      }
      

      console.log(this.selectedLicenceLines,"this.selectedLicenceLines")
    }
  }
};
</script>
<style lang="scss">
.cmp-catalog-releases-sidewindow-licences {
  // .dt-ntable {
  //   --ntable-height: 170px;
  // }
}
</style>
